<p> {{ student.user ? student.user.last_name : student.surname }} {{ student.user ? student.user.first_name : student.name }}</p>